function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "-38 -40 340 340"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M271 858.69C210.31 848 163.89 795.12 163.89 731.56c0-70.71 57.85-128.56 128.56-128.56S421 660.85 421 731.56c0 63.56-46.42 116.42-107.13 127.13l-7.14-5.69h-28.57Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-163.89 -603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.44 767.27 5.71-35.71h-34.28v-25c0-10 3.57-17.86 19.28-17.86h16.43v-32.85C340.29 654.42 330.3 653 321 653c-29.28 0-50 17.86-50 50v28.57h-32.12v35.71H271V858a108.2 108.2 0 0 0 42.85 0v-90.7Z",
    style: {
      fill: "#0c1e34"
    },
    transform: "translate(-163.89 -603)"
  }));
};
export default SvgFacebook;